
import React, { useEffect, useRef, memo } from 'react';
import AppRoutes from './AppRoutes';
import { detectAndResolveAuthLimbo } from '@/utils/auth/authCleanup';
import RouteTransitionTimings from '@/components/routing/RouteTransitionTimings';
import RoutePrefetcher from '@/components/routing/RoutePrefetcher';

/**
 * EnhancedAppRoutes - Wrapper for AppRoutes with stability improvements
 */
const EnhancedAppRoutes: React.FC = () => {
  const cleanupRun = useRef(false);
  
  // Run auth limbo detection once on component mount
  useEffect(() => {
    // Skip if already run
    if (cleanupRun.current) return;
    
    if (typeof window !== 'undefined') {
      try {
        // Detect and resolve auth limbo states
        detectAndResolveAuthLimbo();
        cleanupRun.current = true;
      } catch (error) {
        // Fail gracefully
        console.error('[Auth] Error during auth check:', error);
      }
    }
    
    return () => {
      cleanupRun.current = false;
    };
  }, []);
  
  return (
    <React.Fragment>
      <AppRoutes />
      
      {/* Add performance monitoring for routes in non-production */}
      {process.env.NODE_ENV !== 'production' && <RouteTransitionTimings />}
      
      {/* Route prefetcher for improved navigation */}
      <RoutePrefetcher />
    </React.Fragment>
  );
};

export default memo(EnhancedAppRoutes);
